import { connect } from 'react-redux';
import View from './AccountsManualStepView';
import { viewIdSelector } from './AccountsManualStepSelector';
import {
  currentClientIdOrDefaultSelector,
  iterator,
  isBusySelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { fetchDataIfNecessary } from '../../AdvWorkflow/AdvWorkflowCacheActions';
import dirtyNodesMapSelector from '../../AdvWorkflow/AdvWorkflowCacheSelector';
import { OVERVIEW } from './AccountsManualStepViews';
import { setViewId, setDraftAccount } from './AccountsManualStepActions';
import { BACKEND_KEY, BASE_ACCOUNT } from '../FinancialAccountsWorkflowConstants';
import { buildMutation } from '../../AdvWorkflow/AdvWorkflowHelpers';
import { updateValidation, updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';

const mapStateToProps = (state, ownProps) => ({
  iterator: iterator(state, ownProps),
  clientId: currentClientIdOrDefaultSelector(state, ownProps),
  viewId: viewIdSelector(state, ownProps),
  isBusy: isBusySelector(state, ownProps),
  dirtyNodesMap: dirtyNodesMapSelector(state, ownProps),
});
const mapDispatchToProps = (dispatch, props) => ({
  fetchData: (workflowId, clientId, dirtyNodesMap) => {
    dispatch(fetchDataIfNecessary(workflowId, clientId, ['Accounts'], dirtyNodesMap, false));
  },
  onBack: () => {
    const { workflowId, clientId } = props;

    dispatch(
      updateValidation(
        buildMutation(`${BACKEND_KEY}.AccountsLinkingSteps`, []),
        workflowId,
        clientId,
      ),
    );

    dispatch(
      updateSupportData(
        {
          link: null,
          linkInstitutions: null,
          userID: null,
          password: null,
          accountsLinkingViewID: null,
          selectedInstitution: null,
          requestedResponse: null,
          requestedWith: null,
          typedInstitution: null,
        },
        workflowId,
      ),
    );

    dispatch(setDraftAccount(BASE_ACCOUNT, workflowId));

    dispatch(setViewId(OVERVIEW, workflowId));

    dispatch(setViewId(OVERVIEW, props.workflowId));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(View);
